import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { patientsApi } from '../services/api';
import type { UpdateEnrichmentInput } from '../types';

export function usePatients() {
  return useQuery({
    queryKey: ['patients'],
    queryFn: async () => {
      const response = await patientsApi.getAll();
      return response.data;
    },
  });
}

export function usePatient(id: number) {
  return useQuery({
    queryKey: ['patients', id],
    queryFn: async () => {
      const response = await patientsApi.getById(id);
      return response.data;
    },
    enabled: !!id,
  });
}

export function useUpdateEnrichment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateEnrichmentInput }) =>
      patientsApi.updateEnrichment(id, data),
    onSuccess: (_, { id }) => {
      void queryClient.invalidateQueries({ queryKey: ['patients'] });
      void queryClient.invalidateQueries({ queryKey: ['patients', id] });
    },
  });
}

export function useImportPatients() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => patientsApi.importCsv(file),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['patients'] });
    },
  });
}
